import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CollectionsBootstrap from 'modules/security_settings/lib/CollectionsBootstrap'

const RootPage = () => {
  useEffect(() => {
    track(trackingEvents.security.goToSecuritySettings)
  }, [])

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
